import type { PostalCodeValidator } from "../types";
import { successResult, errorResult } from "../utils";

export const validateIN: PostalCodeValidator = (args) => {
    const { postalCode, isBillingForm, headers } = args;
    if (isBillingForm) return Promise.resolve(successResult());

    // India PIN code is exactly 6 digits, starting with 1-9
    const pinRegex = /^[1-9][0-9]{5}$/;

    const normalizedPostalCode = postalCode?.trim() ?? "";
    if (!normalizedPostalCode) return Promise.resolve(successResult());

    if (!pinRegex.test(normalizedPostalCode)) {
        return Promise.resolve(
            errorResult(headers?.errors?.zipCodeValid ?? "", "undeliverableAddress")
        );
    }

    return Promise.resolve(successResult());
};
